import React from 'react';

const ListBulletsIcon = (props: object) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.3125 7.5H25.3125"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3125 15H25.3125"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3125 22.5H25.3125"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.15625 8.90625C5.9329 8.90625 6.5625 8.27665 6.5625 7.5C6.5625 6.72335 5.9329 6.09375 5.15625 6.09375C4.3796 6.09375 3.75 6.72335 3.75 7.5C3.75 8.27665 4.3796 8.90625 5.15625 8.90625Z"
        fill="currentColor"
      />
      <path
        d="M5.15625 16.4062C5.9329 16.4062 6.5625 15.7767 6.5625 15C6.5625 14.2233 5.9329 13.5938 5.15625 13.5938C4.3796 13.5938 3.75 14.2233 3.75 15C3.75 15.7767 4.3796 16.4062 5.15625 16.4062Z"
        fill="currentColor"
      />
      <path
        d="M5.15625 23.9062C5.9329 23.9062 6.5625 23.2767 6.5625 22.5C6.5625 21.7233 5.9329 21.0938 5.15625 21.0938C4.3796 21.0938 3.75 21.7233 3.75 22.5C3.75 23.2767 4.3796 23.9062 5.15625 23.9062Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ListBulletsIcon;
